import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const TagInput = ({ tags, onChange }) => {
  const [inputValue, setInputValue] = useState('');

  const handleAddTag = () => {
    const trimmedValue = inputValue?.trim()?.toLowerCase();
    if (!trimmedValue) return;

    if (tags?.includes(trimmedValue)) {
      alert('Tag already exists');
      return;
    }

    onChange([...tags, trimmedValue]);
    setInputValue('');
  };

  const handleRemoveTag = (tagToRemove) => {
    onChange(tags?.filter(tag => tag !== tagToRemove));
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter') {
      e?.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div>
      {/* Tag Input */}
      <div className="flex gap-8 mb-12">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e?.target?.value)}
          onKeyDown={handleKeyDown}
          placeholder="Add a tag..."
          className="flex-1 px-16 py-12 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <button
          onClick={handleAddTag}
          disabled={!inputValue?.trim()}
          className="px-20 py-12 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Add
        </button>
      </div>

      {/* Tag List */}
      {tags?.length > 0 && (
        <div className="flex flex-wrap gap-8">
          {tags?.map((tag) => (
            <div
              key={tag}
              className="inline-flex items-center gap-8 px-12 py-6 bg-primary/10 text-primary rounded-lg text-sm"
            >
              <span>#{tag}</span>
              <button
                onClick={() => handleRemoveTag(tag)}
                className="hover:text-destructive transition-colors"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          ))}
        </div>
      )}

      <p className="text-xs text-muted-foreground mt-8">
        Tags help users find your article. Press Enter or click Add to create a tag.
      </p>
    </div>
  );
};

export default TagInput;